import { voidFn } from '@simplisafe/ewok'
import { match } from 'ts-pattern'

/**
 * Logs something to the console in development mode.
 * @param string The string to log
 * @returns void
 * @example
 * ```ts
 * devLog('This is a log')
 * ```
 */

export function devLog(string: string): void {
  match(process.env['NODE_ENV'] || import.meta.env?.MODE)
    .with('development', () => {
      console.log(string)
    })
    .otherwise(voidFn)
}
